import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowsComponent } from './shows.component';
import { ShowsService } from './services/shows.service';
import { MaterialModule } from '../app-material.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShowFormComponent } from './components/show-form/show-form.component';
import { ShowFirstStepComponent } from './components/show-form/show-first-step/show-first-step.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { ShowSecondStepComponent } from './components/show-form/show-second-step/show-second-step.component';
import { ShowThirdStepComponent } from './components/show-form/show-third-step/show-third-step.component';
import { ShowSeatStepComponent } from './components/show-form/show-third-step/show-seat-step/show-seat-step.component';
import { BookingsService } from './services/bookings.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule
  ],
  declarations: [
    ShowsComponent,
    ShowFormComponent,
    ShowFirstStepComponent,
    ShowSecondStepComponent,
    ShowThirdStepComponent,
    ShowSeatStepComponent,
  ],
  providers: [
    ShowsService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    BookingsService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
  ],
  exports: [
    ShowsComponent,
  ]
})
export class ShowsModule { }
